import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import {map} from 'rxjs/operators';
import {AccountService} from '../../singelton/account.service';
@Injectable({providedIn: 'root' })
export class UserGuard implements CanActivate {
  constructor(private accountService: AccountService , private router: Router) {}
  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
   if(this.accountService.isAuthenticated()) {
     //alert(" inside true --------  >>>>>>")
     // if (this.accountService.hasAnyAuthority(['ROLE_ADMIN']) || this.accountService.hasAnyAuthority(['ROLE_DASHBOARD'])) {
     //   // alert(' in admin');
     //   this.router.navigate(['']);
     // } else if (this.accountService.hasAnyAuthority(['ROLE_CLIENT'])) {
     //   // alert(' in client');
     //
     //   this.router.navigate(['page/tickets']);
     // } else {
     //   // alert(' in else');
     //
     //   this.router.navigate(['/page/mytransaction']);
     // }

     return true;
   } else{
  //   alert(" inside false --------  <<<<<<")

     this.router.navigate(['/authentication/login']);
     return false;
   }
      }
    }
